import { useMemo } from "react";
import { useScoringPreview } from "./useScoringPreview";
import { useQuiz } from "./useQuizzes";
import { useScoringRules } from "./useScoringRules";

interface QuizConfigWithTags {
  suggested_product_tags?: string[];
}

export function useTagSuggestions(quizId: string | null): {
  tags: string[];
  isLoading: boolean;
} {
  const { data: previewData, isLoading: previewLoading } =
    useScoringPreview(quizId);
  const { data: quiz, isLoading: quizLoading } = useQuiz(quizId ?? undefined);
  const { data: rulesData, isLoading: rulesLoading } = useScoringRules(
    quizId ?? undefined,
  );

  const tags = useMemo(() => {
    const set = new Set<string>();

    for (const tag of previewData?.summary?.allTags ?? []) {
      set.add(tag);
    }

    const configured =
      (quiz?.configuration as QuizConfigWithTags | undefined)
        ?.suggested_product_tags ?? [];
    for (const tag of configured) {
      set.add(tag);
    }

    for (const rule of rulesData?.rules ?? []) {
      if (rule.targetValue) set.add(rule.targetValue);
    }

    return Array.from(set).sort();
  }, [previewData, quiz, rulesData]);

  return {
    tags,
    isLoading: previewLoading || quizLoading || rulesLoading,
  };
}
